import useWindowPositionTop from 'hooks/useWindowPositionTop';

export default function CourseForTraveling() {
    useWindowPositionTop();
  return (
    <>
      <style>{`
        .express-course {
          white-space: pre-line;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          margin: 0 auto;
          padding: 8rem 2rem;
          box-sizing: border-box;
          background: #fff;
          color: #222;
          border-radius: 8px;
          transition: padding 0.3s ease;
          max-width: 720px;
        }

        .express-course h2 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #003366;
          line-height: 1.1;
        }

        .express-course p {
          margin-bottom: 1.25rem;
          font-size: 1.125rem;
          font-weight: 400;
          color: #333;
        }

        .express-course ul {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
          list-style-type: disc;
          color: #444;
        }

        .express-course ul li {
          margin-bottom: 0.6rem;
          font-size: 1.05rem;
          line-height: 1.4;
        }

        .express-course strong {
          font-weight: 700;
          color: #002244;
        }

        .express-course .highlight {
          font-weight: 700;
          font-size: 1.2rem;
          color: #b22222;
          margin-top: 2rem;
        }

        /* Responsive typography and spacing */
        @media (max-width: 1024px) {
          .express-course h2 {
            font-size: 1.9rem;
          }
          .express-course p,
          .express-course ul li {
            font-size: 1rem;
          }
        }

        @media (max-width: 600px) {
          .express-course h2 {
            font-size: 1.6rem;
          }
          .express-course p,
          .express-course ul li {
            font-size: 0.95rem;
          }
          .express-course ul {
            padding-left: 1.2rem;
          }
        }

        @media (max-width: 360px) {
          .express-course h2 {
            font-size: 1.4rem;
          }
          .express-course p,
          .express-course ul li {
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="express-course">
        <h2>ЭКСПРЕСС-КУРС английского языка для выезда за границу</h2>
        <p>Устали ждать результатов? Хотите быстро освоить английский без долгих лет обучения?</p>
        <p>Тогда интенсивный экспресс-курс — ваш шанс овладеть английским языком всего за 16 занятий!</p>

        <p><strong>⚡️ Почему экспресс-курс — это ваш идеальный выбор:</strong></p>
        <ul>
          <li>Максимальная концентрация на ключевых аспектах языка</li>
          <li>Сжатые сроки обучения без потери качества</li>
          <li>Конкретные результаты уже после первых занятий</li>
          <li>Практический подход к изучению</li>
        </ul>

        <p><strong>🎯 ЧТО ВЫ ПОЛУЧИТЕ ЗА 16 ЗАНЯТИЙ:</strong></p>
        <ul>
          <li>Уверенное владение базовым словарным запасом</li>
          <li>Навыки построения простых и сложных предложений</li>
          <li>Способность вести диалог на повседневные темы</li>
          <li>Понимание разговорной речи на слух</li>
          <li>Базовые навыки делового общения</li>
        </ul>

        <p><strong>🏆 ПРОГРАММА КУРСА:</strong></p>
        <ul>
          <li>Основы грамматики — фундамент вашего английского</li>
          <li>Разговорная практика — учимся говорить сразу</li>
          <li>Аудирование по фильмам и мультфильмам — развиваем понимание речи</li>
          <li>Практическая лексика — учим только то, что нужно</li>
        </ul>

        <p><strong>🎯 ДЛЯ КОГО ЭТОТ КУРС:</strong></p>
        <ul>
          <li>Бизнесменов, которым нужен быстрый результат</li>
          <li>Путешественников, планирующих поездки</li>
          <li>Студентов перед экзаменами</li>
          <li>Всех, кто хочет быстро освоить язык</li>
        </ul>

        <p><strong>🎁 БОНУСЫ КУРСА:</strong></p>
        <ul>
          <li>Персональный план обучения</li>
          <li>Дополнительные материалы для практики</li>
          <li>Моя ежедневная поддержка</li>
          <li>Каждое занятие в записи</li>
        </ul>

        <p><strong>💰 СПЕЦИАЛЬНОЕ ПРЕДЛОЖЕНИЕ:</strong></p>
        <ul>
          <li>Скидка 20% на весь курс</li>
          <li>Бесплатный пробный урок</li>
          <li>Гибкий график занятий</li>
          <li>Индивидуальный подход</li>
        </ul>

        <p><strong>⏰ СРОКИ И ФОРМАТ:</strong></p>
        <ul>
          <li>16 интенсивных занятий</li>
          <li>Удобное расписание</li>
          <li>Онлайн или офлайн формат</li>
          <li>Группы до 6 человек</li>
        </ul>

        <p>
          Не упустите шанс освоить английский быстро и эффективно!
        </p>

        <p className="highlight">
          📞 ЗАПИШИТЕСЬ ПРЯМО СЕЙЧАС!<br />
          Количество мест ограничено!<br />
          Ваш путь к свободному английскому начинается здесь и сейчас!
        </p>

        <p>#экспресскурс #английскийязык #быстроеобучение #интенсив #английскийдлявзрослых</p>
      </div>
    </>
  );
}

